import Linkify from "linkify-react";
import type { JSX } from "react";
import { lookupAiTranslation } from "../aiTranslationUtils";
import type { ContentFormat } from "../types";
import RenderMark from "./RenderMark";

interface IProps {
    content?: string | null;
    contentFormat?: ContentFormat | null;
    translations?: Record<string, string>;
}

function RenderContent({ content, contentFormat, translations }: IProps): JSX.Element | null {
    if (!content) {
        return null;
    }

    const translated = lookupAiTranslation(content, translations);

    const isMarkdown = contentFormat === "MARKDOWN" || contentFormat === "MARKDOWN_HTML";
    const unsafe = contentFormat === "MARKDOWN_HTML";

    if (isMarkdown) {
        return <RenderMark content={translated} unsafe={unsafe} />;
    }

    return (
        <Linkify options={{ nl2br: true }} tagName="p">
            {translated}
        </Linkify>
    );
}

export default RenderContent;
